module.exports = __webpack_public_path__ + "img/eyes_female_average_mask.34836e9e.png";